/* eslint-disable camelcase */
export enum SimulateAllTypes {
  GET_SIMULATE_REQUEST = '@simulate/GET_SIMULATE_REQUEST',
  GET_SIMULATE_SUCCESS = '@simulate/GET_SIMULATE_SUCCESS',
  GET_SIMULATE_FAILURE = '@simulate/GET_SIMULATE_FAILURE',
  UPDATE_STATE_ASSINATURA_DIGITAL = '@simulate/UPDATE_STATE_ASSINATURA_DIGITAL',
  UPDATE_STATE_SERVICO_ADICIONAL = '@simulate/UPDATE_STATE_SERVICO_ADICIONAL',
}

export interface ServiceTypes {
  descricao: string | null;
  id: number;
  nome: string;
  plano: string;
  quantidade: number;
  status_id: number;
  valor: number;
  valor_adicional: number;
  valor_servico: number;
  valor_servico_cartao: number;
  valor_unitario: string;
  assinatura_digital: boolean;
}
export interface OriginalTypes {
  servicos: Array<ServiceTypes>;
  total_maximo_parcelas: number;
  valor_adicional: number;
  valor_base: number;
  valor_final: number;
  valor_negociacao: number;
  valor_parcela: number;
  valor_total_no_cartao: number;
  valor_variacao_forma_pagamento: number;
}

export interface PlanTypes {
  original: OriginalTypes;
}

export interface PlanDadosTypes {
  original: {
    [key: string]: {
      [key: string]: PlanTypes;
    };
  };
  package_name: string;
  plan_id: string;
  renewal: boolean;
}

export interface AssinaturaDigitalTypes {
  assinatura_digital: boolean;
}

export interface ServicoAdicionalTypes {
  servico_adicional: boolean;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface SimulateState {
  simulate: PlanDadosTypes;
  readonly requestSimulate: RequestState;
  readonly assinaturaDigital: AssinaturaDigitalTypes;
  readonly servicoAdicional: ServicoAdicionalTypes;
}
